/* eslint-disable import/prefer-default-export */
export enum FeatureType {
  CLASS = 1
}
